module.exports = "/static/assets/72aa95ab24a5871c58624e4f045b6cad.png";